import { render } from "./CreateAnEventPage.vue?vue&type=template&id=f56dd794&ts=true"
import script from "./CreateAnEventPage.vue?vue&type=script&lang=ts"
export * from "./CreateAnEventPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__